/**
 * @module styled-components
 */

import styled from "styled-components";

/**
 * Standardized close button component.
 */
export default styled.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  -webkit-transition: all ease 0.25s;
  -moz-transition: all ease 0.25s;
  transition: all ease 0.25s;
  display: flex;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  background-color: transparent;
  line-height: ${props => props.lineHeight || "normal"};
  font-size: 16px;
  padding: 0 1.5rem;
  vertical-align: middle;
  text-align: center;
  &:hover {
    border: 0;
    background-color: ${props => props.theme.button.close.hover};
    color: ${props => props.theme.text.primaryInverted};
  }
  &:active {
    border: 0;
    background-color: ${props => props.theme.button.close.active};
  }
`;



// WEBPACK FOOTER //
// ./app/styled-components/CloseButton.js